import { render, staticRenderFns } from "./aiTesterTourist.vue?vue&type=template&id=2106500d"
import script from "./aiTesterTourist.vue?vue&type=script&lang=js"
export * from "./aiTesterTourist.vue?vue&type=script&lang=js"
import style0 from "./aiTesterTourist.vue?vue&type=style&index=0&id=2106500d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports